const SESSION_KEY = "aim_session";
const TOKEN_KEY = "aim_token";
const REFRESH_TOKEN_KEY = "aim_refresh_token";
const EXP_KEY = "aim_exp";
const SESSION_EVENT = "aim-session-changed";

const emitSessionChange = () => {
  window.dispatchEvent(new Event(SESSION_EVENT));
};

export const Session = {
  set: (session, token, refreshToken,expiresInMinutes = 60) => {
    const expiryTime = Date.now() + expiresInMinutes * 60 * 1000;

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem( REFRESH_TOKEN_KEY,refreshToken);
    sessionStorage.setItem(EXP_KEY, expiryTime.toString());
    
    emitSessionChange();
  },

  get: () => {
    const data = sessionStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : null;
  },

  getToken: () => sessionStorage.getItem(TOKEN_KEY),
  getRefreshToken: () =>sessionStorage.getItem( REFRESH_TOKEN_KEY),
  getExpiry: () => {
    const exp = sessionStorage.getItem(EXP_KEY);
    return exp ? Number(exp) : null;
  },

  isAuthenticated: () => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    const refreshToken = sessionStorage.getItem(REFRESH_TOKEN_KEY);
    return !!(token && refreshToken);
    // if (!token || !exp) return false;

    // if (Date.now() >= Number(exp)) {
    //   Session.clear();
    //   return false;
    // }

    // return true;
  },

  getUserId: () => Session.get()?.userId,
  getUserName: () => Session.get()?.username,
  getEmail: () => Session.get()?.email,
  getRole: () => Session.get()?.roleName,
   getWorkspacesName: () => Session.get()?.workspaces,

  clear: () => {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(EXP_KEY);
    emitSessionChange();
  }
};
